"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const q = require("logic-query-parser");
function parse(queryString) {
    const values = typeof queryString === "string" ? [queryString] : [];
    try {
        const parsed = q.parse(queryString);
        const query = q.utils.binaryTreeToQueryJson(parsed);
        if (query.type) {
            return query;
        }
        return { type: "and", values };
    }
    catch (err) {
        return { type: "and", values };
    }
}
exports.parse = parse;
function perform(query, predicate) {
    if (typeof query === "string") {
        return predicate(query);
    }
    switch (query.type) {
        case "and": {
            const items = () => query.values.map(value => perform(value, predicate));
            return lodash_1.intersection(...items());
        }
        case "or": {
            const items = () => query.values.map(value => perform(value, predicate));
            return lodash_1.flatten([...items()]);
        }
        case "string": {
            const value = typeof query.value === "string" ? query.value : "";
            return predicate(value);
        }
        default: {
            throw new TypeError(`@patternplate/search.perform: Unknown query: ${JSON.stringify(query)}`);
        }
    }
}
exports.perform = perform;
//# sourceMappingURL=query.js.map